import React, { useContext, useEffect } from 'react';

import { FlowConfigContext } from '../providers/FlowConfigContext';
import StatusEventPayload, { NOT_FOUND } from '../services/events/statusEventPayload';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import Container from '../common/components/Container/Container';
import Loading from '../common/components/Loading/Loading';
import { Screens } from '../services/analytics/screens';

const GenericStatusScreen: React.FC = () => {
  const { initialized, flowSuccessful } = useContext(FlowConfigContext);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    flowSuccessful(new StatusEventPayload(NOT_FOUND));
  }, [initialized]);

  return (
    <Container>
      <Loading dataTestId="IN_PROGRESS" />
    </Container>
  );
};

export default withRouteAnalytics(GenericStatusScreen, Screens.GENERIC_STATUS);
